module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_rushing_tds/green-ec7ccbcce0cbb434b1e3352da7d0eb5b.svg";